<template>
  <div class="footer fixed-bottom bg-primary text-white small">
      <div class="row h-100 justify-content-around">
          <div class="col-auto col-md text-nowrap align-content-center text-center"> 
              <span class="" style="font-size:0.8rem">
                  © {{ moment().year() }} Powered By Makbill
              </span>
          </div>
        
      </div>
  </div>

</template>

<script>

export default {
name: 'TheFooter',
data() {
  return {};
},
};
</script>
